import { render, staticRenderFns } from "./ShuJuZhongXingYuanQu.vue?vue&type=template&id=774e842a&scoped=true&"
import script from "./ShuJuZhongXingYuanQu.vue?vue&type=script&lang=js&"
export * from "./ShuJuZhongXingYuanQu.vue?vue&type=script&lang=js&"
import style0 from "./ShuJuZhongXingYuanQu.vue?vue&type=style&index=0&id=774e842a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "774e842a",
  null
  
)

export default component.exports